var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stato-fase',{attrs:{"fase-with-stati":_vm.faseWithStati,"pratica":_vm.pratica,"pratica-diff":_vm.praticaDiff,"disabled":_vm.isLoading,"action":_vm.action},on:{"update-id-stato":function($event){_vm.pratica.id_stato_fase_5 = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }